import { apiUser } from "../Api/ApiInstance";

export async function SaveOrder(values) {
  return await apiUser.post("api/nexus-main/order", values);
}

export async function Orders() {
  return await apiUser.get("api/nexus-main/order");
}

export async function SaveOrderDetail(values) {
  return await apiUser.post("api/nexus-main/order/detail", values);
}

export async function GetOrderDetail(ordenId) {
  return await apiUser.get(`api/nexus-main/order/detailOrder/${ordenId}`);
}

export async function UpdateOrderPay(values) {
  return await apiUser.post("api/nexus-main/order/pay", values);
}
